var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandLizard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.999 330V432C511.999 440.836 504.835 448 495.999 448H367.999C359.163 448 351.999 440.836 351.999 432V416L266.665 352H95.999C79.528 352 64.561 338.562 64.034 322.102C62.87 285.793 91.956 256 127.999 256H232.934C246.708 256 258.936 247.188 263.292 234.117L273.96 202.117C280.866 181.398 265.444 160 243.602 160H63.999C27.954 160 -1.13 130.199 0.034 93.898C0.561 77.438 15.53 64 31.999 64H303.21C329.465 64 354.051 76.883 368.999 98.469L497.77 284.453C507.036 297.836 511.999 313.723 511.999 330Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandLizard);
export default __webpack_public_path__ + "static/media/hand-lizard.e8602acbfdac3681d4917838219c1d8f.svg";
export { ForwardRef as ReactComponent };